import $ from '../javascript/common/jquery.js';
import Player from '../javascript/dnsound/player.js';
import Sounds from '../javascript/dnsound/sounds.js';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.js-dnsound-control-deck')) {
    const sounds = new Sounds();
    const records = '.js-dnsound-records-table tbody tr';
    const notes = $('.js-dnsound-notes').text();
    const domainName = $('.js-dnsound-domain-name').text();
    new Player(sounds, records, notes, domainName);
  }
});
